module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/technical/qc-type/qc-type-grid/qc-type-grid.component.css
// module id = ./src/app/technical/qc-type/qc-type-grid/qc-type-grid.component.css
// module chunks = main